import { format } from 'date-fns';

/**
 * @param blob
 * @param {string} name
 * @param {string} extension
 * @param {boolean} dated
 * @return {boolean}
 */
export function downloadFile(blob, name, extension, dated = false) {
  blob = blob.data;

  let type = null;
  if (extension === 'pdf') {
    type = 'application/pdf';
  } else if (extension === 'docx') {
    type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  } else if (extension === 'csv') {
    type = 'text/csv';
  }

  const newBlob = new Blob([blob], {type: type});
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return true;
  }

  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = (dated ? format(new Date(), 'yyyyMMdd') + '-' : '') + name + '.' + extension;

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
  return true;
}

/**
 * @param {number} universeId
 * @return {string}
 */
export function getSkillsFileUrl(universeId) {
  return `${process.env.API_URL}/universes/${universeId}/skills-file`;
}

/**
 * @param {number} universeId
 * @return {string}
 */
export function getSkillsFileExampleUrl(universeId) {
  return `${process.env.API_URL}/universes/${universeId}/skills-file-example`;
}